import { AttributeIdentifiers } from "@lyfegen-platform/graphql-schema/models";
import { Box, Typography, useTheme } from "@material-ui/core";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import useStyles from "../containers/data/forms/forms-styles";
import { FlexContext } from "../models/flexible/flex-context";
import { FlexFieldController } from "../models/flexible/flex-field-controller";
import { FlexSectionController } from "../models/flexible/flex-section-controller";
import { FlexSectionSchema } from "../models/flexible/flex-section-schema";
import { Maybe } from "../models/generated/graphql";

export class CaseIdContainerSectionController implements FlexSectionController {
	context: FlexContext = {} as any;

	constructor(
		readonly schema: FlexSectionSchema,
		readonly path: string,
		readonly fieldControllers: Array<FlexFieldController>,
		readonly sectionControllers: Array<FlexSectionController>
	) {}

	renderAfterRowContent(path: string, isFirst: boolean): Maybe<React.ReactElement> {
		const { t } = useTranslation();
		const { palette } = useTheme();
		const styles = useStyles();
		const caseIds = this.context.cases.filter((cs) => !cs.baseAgreement.isHidden).map((cs) => cs.id);
		const isMultiplePatient = this.context.noPatients && this.context.noPatients > 0;
		if (isMultiplePatient) return <></>;
		if (
			!isFirst ||
			this.schema.position > 0 ||
			this.schema.fields.some(
				(field) =>
					field.attribute.identifier === AttributeIdentifiers.AdministrationDate ||
					field.attribute.identifier === AttributeIdentifiers.PrescriptionDate
			)
		) {
			return null;
		}

		return (
			<Box className={styles.colMedium} pl={1.5} pr={5} paddingY={2.5}>
				<Typography variant="caption" style={{ color: palette.enabledHeader.main }}>
					{t("case-id")}
				</Typography>
				{!caseIds?.length && (
					<Typography style={{ color: palette.text.disabled }}>{t("will-be-generated-automatically")}</Typography>
				)}
				{!!caseIds?.length && (
					<Box display="flex">
						{caseIds.map((caseId, i) => (
							<Fragment key={i}>
								<Link to={`/cases/case?id=${caseId}`}>{caseId}</Link>
								{i < caseIds.length - 1 && <Box mr={1}>, </Box>}
							</Fragment>
						))}
					</Box>
				)}
			</Box>
		);
	}
}
